/**
 * @generated SignedSource<<fc9044f1d36c967d083a2a3dba26b53e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdatePersonalizedEmailTemplateInput = {
  clientMutationId?: string | null | undefined;
  data: PersonalizedEmailTemplateInput;
  id: string;
};
export type PersonalizedEmailTemplateInput = {
  body: string;
  key: string;
  previewText: string;
  subject: string;
  variables: ReadonlyArray<string>;
};
export type EditEmailTemplateScreen_UpdatePersonalizedEmailTemplateMutation$variables = {
  input: UpdatePersonalizedEmailTemplateInput;
};
export type EditEmailTemplateScreen_UpdatePersonalizedEmailTemplateMutation$data = {
  readonly Admin: {
    readonly Email: {
      readonly updatePersonalizedEmailTemplate: {
        readonly data: {
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"EditEmailTemplateScreen_EmailTemplateFragment">;
          };
        };
      } | null | undefined;
    };
  };
};
export type EditEmailTemplateScreen_UpdatePersonalizedEmailTemplateMutation = {
  response: EditEmailTemplateScreen_UpdatePersonalizedEmailTemplateMutation$data;
  variables: EditEmailTemplateScreen_UpdatePersonalizedEmailTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditEmailTemplateScreen_UpdatePersonalizedEmailTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Email",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "UpdatePersonalizedEmailTemplatePayload",
                "kind": "LinkedField",
                "name": "updatePersonalizedEmailTemplate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonalizedEmailTemplatesEdge",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonalizedEmailTemplate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "EditEmailTemplateScreen_EmailTemplateFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditEmailTemplateScreen_UpdatePersonalizedEmailTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Email",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "UpdatePersonalizedEmailTemplatePayload",
                "kind": "LinkedField",
                "name": "updatePersonalizedEmailTemplate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonalizedEmailTemplatesEdge",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonalizedEmailTemplate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EmailTemplate",
                            "kind": "LinkedField",
                            "name": "template",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "key",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "subject",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "previewText",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "body",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "variables",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fa1182bbf93d2034f66b585cf48af65c",
    "id": null,
    "metadata": {},
    "name": "EditEmailTemplateScreen_UpdatePersonalizedEmailTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation EditEmailTemplateScreen_UpdatePersonalizedEmailTemplateMutation(\n  $input: UpdatePersonalizedEmailTemplateInput!\n) {\n  Admin {\n    Email {\n      updatePersonalizedEmailTemplate(input: $input) {\n        data {\n          node {\n            ...EditEmailTemplateScreen_EmailTemplateFragment\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EditEmailTemplateScreen_EmailTemplateFragment on PersonalizedEmailTemplate {\n  id\n  template {\n    key\n    subject\n    previewText\n    body\n    variables\n  }\n}\n"
  }
};
})();

(node as any).hash = "bc1211d3d394a62d67ab8d68f3e4f517";

export default node;
